import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-rates-list',
  templateUrl: './rates-list.component.html',
  styleUrls: ['./rates-list.component.scss'],
})
export class RatesListComponent implements OnInit {
  @Input() isLoading: boolean = false;
  @Input() totalItems: number = 0;
  @Input() ratesList: any[] = [];
  @Input() canDelete: boolean = false;
  @Input() redirectUrl =
    '/dashboard/contracts/rate-list/ratecard-overview/information/';
  @Output() deleteRate = new EventEmitter<any>();
  tableSelected: any = {};
  isMobile: boolean = window.innerWidth < 768 ? true : false;
  schemaLoading: any = ['', '', '', '', '', '', '', '', '', ''];
  tableName: string = 'Rates';
  tableOptions: any = [
    'SORT PRIORITY',
    'CODE',
    'RATE NAME',
    'PRODUCT NAME',
    'PRODUCT TYPE',
    'VEHICLE TYPE',
    'PLAN/ PROGRAM NAME',
    'DEDUCTIBLE',
    'STATUS',
  ];
  constructor() {}

  ngOnInit(): void {}

  handleOutput(output: string) {
    this.tableSelected = output;
  }

  handleDelete(rate: any): void {
    this.deleteRate.emit(rate);
  }
}
